import * as React from 'react';

export function PseudoEmailRow() {
    return (
        <div className='flex'>
            Email (
            <i>
                Automatically tracked by email sync.{' '}
                <a
                    href='https://support.nutshell.com/en/articles/8429007-activity-types-create-custom-activity-types'
                    style={{color: '#1a73e8', textDecoration: 'none'}}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    Learn more
                </a>
            </i>
            )
        </div>
    );
}
